import { useRef } from 'react';

import { useHost } from '@xingternal/crate-core-runtime-helper';
import type { Variant, ExperimentType } from '@xingternal/splitkit';
import { registerExperiment } from '@xingternal/splitkit';

type ContributesExperiments = {
  experiments: {
    name: string;
    supportedVariants: ['A', ...Variant[]];
    experimentType?: ExperimentType;
  }[];
};

export const useRegisterExperiments = (): void => {
  const host = useHost();
  const metadata = host.getXingletMetadata<ContributesExperiments>();
  const registered = useRef(false);

  if (!registered.current) {
    metadata.forEach((data) => {
      data.contributes?.experiments &&
        data.contributes.experiments.forEach(
          ({ name, supportedVariants, experimentType }) => {
            registerExperiment(name, supportedVariants, experimentType);
          }
        );
    });

    registered.current = true;
  }
};
